import React, { Component, Fragment, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import i18n from '../../../../../constants/initLng';
import { PATHS } from '../../../../../constants/Define';
import { useTranslation } from "react-i18next";
import * as CPN from "antd";
import * as Func from "../../../../../helpers/functions";
import routes from '../../../../../routers';
import * as HMS from "../../../common/component/Index";
import Modal from '../../../common/component/Modal';
import Dropdown from '../../../common/component/Dropdown';

let permissionChangeLabelView = ['groups', 'tours']

export const EditComponent = (props) => {
    const { t } = useTranslation();
    const removeRole = () => {
        props.onDeleteRole({ id: props.item.id })
    }
    const onRemove = () => {
        const { confirm } = Modal;
        confirm({
            title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.role.title`)),
            content: props.item.name,
            okText: t(`action.remove`),
            cancelText: t(`action.cancel`),
            onOk: removeRole,
        });
    };
    return (
        <Fragment>
            <Dropdown overlay={
                <CPN.Menu className="action-menu">
                    {
                        props.permisionActions && props.permisionActions.allowUpdate &&
                        <CPN.Menu.Item>
                            <Link to={Func.getPathWithParams(PATHS.ROLE.DETAIL.path, { id: props.item.id })} className={`mr-2`}>
                                <CPN.Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                            </Link>
                        </CPN.Menu.Item>
                    }

                    {
                        props.permisionActions && props.permisionActions.allowDelete &&
                        <CPN.Menu.Item onClick={onRemove}><CPN.Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</CPN.Menu.Item>
                    }
                </CPN.Menu>
            }>
                <CPN.Icon type="more" className="fs20 cursorPointer" />
            </Dropdown>
        </Fragment>
    )
};

export const RolePermission = (props) => {
    const { t } = useTranslation();
    let [permissions, setPermissions] = useState([]);
    let [objectPermission, setObjectPermission] = useState({});

    useEffect(() => {
        let newObjectPermission = { ...objectPermission };
        routes && routes.length > 0 && routes.map((i, k) => {
            if (i.isParrentMenu) {
                i.children && i.children.length > 0 && i.children.map((route) => {
                    newObjectPermission = getObjectPermission(newObjectPermission, route);
                })
            } else {
                newObjectPermission = getObjectPermission(newObjectPermission, i);
            }
        });
        setObjectPermission(newObjectPermission)
        setPermissions(props.permissions);
    }, [props.permissions]);

    const getObjectPermission = (objPermission, route) => {
        objPermission = { ...objPermission, [route.routeName]: true };
        route.permissions && route.permissions.length > 0 && route.permissions.map((item) => {
            let perName = `${route.routeName}.${item}`;
            objPermission = {
                ...objPermission,
                [perName]: props.permissions.includes(perName)
            }
            if (!props.permissions.includes(perName)) {
                objPermission = { ...objPermission, [route.routeName]: false };
            }
        });
        return objPermission;
    }

    const onChange = (e, isCheckAll, route) => {
        let permissionName = e.name;
        let isChecked = e.value;
        let arrayPermission = permissions
        if (isCheckAll) {
            let newObjectPermission = { ...objectPermission, [permissionName]: isChecked };
            route.permissions && route.permissions.length > 0 && route.permissions.map(i => {
                let perName = `${permissionName}.${i}`;
                newObjectPermission = { ...newObjectPermission, [perName]: isChecked }
                if (isChecked) {
                    if (!permissions.includes(perName)) {
                        arrayPermission.push(perName);
                    }
                } else {
                    arrayPermission = Func.arrayRemoveItem(arrayPermission, perName)
                }
            })
            setObjectPermission(newObjectPermission)
        } else {
            let newObjectPermission = { ...objectPermission, [permissionName]: isChecked };
            if (isChecked) {
                if (!permissions.includes(permissionName)) {
                    arrayPermission.push(permissionName);
                }
            } else {
                arrayPermission = Func.arrayRemoveItem(arrayPermission, permissionName)
            }
            setCheckAll(route, newObjectPermission);
        }
        setPermissions(arrayPermission)
        props.onSetPermissions(arrayPermission);
    }

    const setCheckAll = (route, objPermission) => {
        let newObjectPermission = { ...objPermission, [route.routeName]: true };
        let permissionName = route.routeName;
        route.permissions && route.permissions.length > 0 && route.permissions.map(i => {
            let perName = `${permissionName}.${i}`;
            if (!objPermission[perName]) {
                newObjectPermission = { ...objPermission, [route.routeName]: false };
                return;
            }
        })
        setObjectPermission(newObjectPermission);
    }

    return (
        <Fragment>
            <h3 className="mt-3">{t(`item.role.generalManagement`)}</h3>
            <div className="parent-divider ant-divider ant-divider-horizontal" />
            {
                routes && routes.length > 0 && routes.map((i, k) => {
                    return i.routeName && i.isParrentMenu ? (
                        <div key={k}>
                            <h3 className="mt-3">{t('navigation.' + [i.title])}</h3>
                            <div className="parent-divider ant-divider ant-divider-horizontal" />
                            {
                                i.children && i.children.length > 0 && i.children.map((j, n) => {
                                    return <PermissionItem key={n}
                                        onChange={onChange}
                                        route={j}
                                        objPermission={objectPermission}>
                                    </PermissionItem>
                                })
                            }
                        </div>
                    ) : (
                            <PermissionItem key={k}
                                onChange={onChange}
                                route={i}
                                objPermission={objectPermission}>
                            </PermissionItem>
                        )
                })
            }
        </Fragment>
    )
};

export const PermissionItem = (props) => {
    const { t } = useTranslation();

    function getkeyPermission(routeName, item) {
        if((item.split('.')).length < 2) {
            return `${routeName}.${item}`
        }
        return item
    }
    
    function keyLanguagePermission(item, routerTitle) {
        if(permissionChangeLabelView.includes(routerTitle) && item === 'view') {
            return 'viewList'
        }
        const langPermission = item.split('.')
        return langPermission[langPermission.length - 1]
    }

    return (
        <Fragment >
            {props.route.routeName && <div className="row">
                <div className="col-md-4">
                    <HMS.CheckboxComponent
                        name={props.route.routeName}
                        className={`mr-4`}
                        onChange={(e) => props.onChange(e, true, props.route)}
                        checked={props.objPermission[props.route.routeName]}
                    >
                        {t('navigation.' + [props.route.title])}
                    </HMS.CheckboxComponent>
                </div>
                <div className="col-md-8">
                    {
                        props.route.permissions && props.route.permissions.length > 0 && props.route.permissions.map((item, p) => {
                            return <HMS.CheckboxComponent key={p}
                                name={getkeyPermission(props.route.routeName, item)}
                                className={`mr-4 ml-0`}
                                onChange={(e) => props.onChange(e, false, props.route)}
                                checked={props.objPermission[getkeyPermission(props.route.routeName, item)]}
                            >
                                {t('permission.' + [keyLanguagePermission(item, props.route.title)])}
                            </HMS.CheckboxComponent>
                        })
                    }
                </div>
                <div className="child-divider ant-divider ant-divider-horizontal"></div>
            </div>
            }
        </Fragment>
    )
}